import styled from "styled-components";

const gold = "rgba(201, 162, 39, 0.95)";

export const Wrap = styled.aside`
  position: sticky;
  top: 160px;
  align-self: start;

  max-height: calc(120vh - 160px - 16px);
  overflow: auto;
  overscroll-behavior: contain;

  /* ✅ îl facem “cuminte”, ca un panel premium */
  padding: 16px 14px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(6px);
`;

export const Title = styled.h2`
  margin: 0 0 14px;
  font-family: "Cormorant Garamond", serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 1.06;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.86);

  position: relative;
  padding-bottom: 12px;

  /* hairline auriu fin, nu bară groasă */
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1px;
    background: rgba(201, 162, 39, 0.55);
  }
`;

export const List = styled.div`
  padding-top: 10px;
`;

export const Row = styled.button`
  width: 100%;
  border: 0;
  cursor: pointer;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 12px 12px;
  border-radius: 12px;

  background: transparent;

  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  letter-spacing: 0.03em;
  font-size: 19px;

  color: rgba(0, 0, 0, 0.82);
  transition:
    background 160ms ease,
    color 160ms ease,
    transform 160ms ease;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
    color: rgba(0, 0, 0, 0.92);
  }

  ${({ $active }) =>
    $active &&
    `
      background: rgba(252, 154, 196, 0.14);
      color: rgba(0, 0, 0, 0.96);
      transform: translateX(2px);
    `}
`;

export const Name = styled.span`
  position: relative;
  display: inline-block;
  width: fit-content;
  padding-left: 16px;

  &::before {
    content: "◆";
    position: absolute;
    left: 0;
    top: 3px;
    font-size: 10px;
    color: ${gold};
    opacity: ${(p) => (p.$active ? 1 : 0)};
    transition: 0.2s ease;
  }

  /* underline mai fin, fără “bară” groasă */
  &::after {
    content: "";
    position: absolute;
    left: 16px;
    right: 0;
    bottom: -6px;

    height: 2px;
    border-radius: 999px;
    background: rgba(252, 154, 196, 0.95);

    opacity: ${(p) => (p.$active ? 1 : 0)};
    transform: ${(p) => (p.$active ? "scaleX(1)" : "scaleX(0.8)")};
    transform-origin: left;
    transition: 0.2s ease;
  }
`;

export const Count = styled.span`
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  font-size: 16px;
  color: ${(p) => (p.$active ? gold : "rgba(0, 0, 0, 0.52)")};
`;
